<template>
  <div>
    <HeaderComponent  app_title="ECOBUQ" />
    <main>
      <FormEditShip></FormEditShip>
    </main>
    <FooterComponent class="bottom-0"></FooterComponent>
  </div>
</template>

<script>
// @ is an alias to /src
import FooterComponent from "@/components/FooterComponent.vue";
import HeaderComponent from "@/components/HeaderComponent.vue";
import FormEditShip from "@/components/FormEditShip.vue";

export default {
  name: "HomeView",
  components: {
    HeaderComponent,
    FooterComponent,
    FormEditShip,
  },
  created() {},
};
</script>
